import React from "react";
import { Scale, X } from "lucide-react";

/**
 * CompareTray — floating "Compare (N)" pill, always visible while there's at
 * least one site in the comparison set. Mobile-first: lives bottom-center
 * regardless of whether the desktop sidebar (with its inline compare bar) is
 * visible. Tapping the orange CTA navigates to the existing /compare page
 * which already renders the side-by-side table.
 *
 * Props:
 *   count:   number  — current comparison size
 *   onGo:    ()=>void — fires when user taps "Compare". Parent decides what
 *                       happens (typically: navigate to /compare?ids=…).
 *   onClear: ()=>void — clear all selections.
 */
export default function CompareTray({ count = 0, onGo, onClear }) {
  if (count < 1) return null;

  return (
    <div
      className="fixed bottom-20 sm:bottom-6 left-1/2 -translate-x-1/2 z-[9998]"
      data-testid="compare-tray"
    >
      <div className="flex items-center gap-2 bg-[#0e0e0e] text-white rounded-full pl-4 pr-1.5 py-1.5 shadow-[0_10px_30px_-8px_rgba(0,0,0,0.45)] border border-white/10">
        <Scale className="w-4 h-4 text-[#fde047]" strokeWidth={2.2} />
        <span className="mono text-[11px] uppercase tracking-wider">
          <span className="font-bold">{count}</span> picked
        </span>
        <button
          onClick={onGo}
          disabled={count < 2}
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#ff4500] hover:bg-[#e63e00] disabled:opacity-50 disabled:cursor-not-allowed text-[11px] font-bold uppercase tracking-wider transition-colors"
          data-testid="compare-tray-go"
        >
          Compare
        </button>
        <button
          onClick={onClear}
          aria-label="Clear comparison"
          className="p-1 text-white/60 hover:text-white"
          data-testid="compare-tray-clear"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
      {count < 2 && (
        <div className="mt-1.5 mx-auto max-w-[210px] text-center mono text-[10px] uppercase tracking-wider text-[#0e0e0e] bg-[#fde047] rounded-full px-2 py-0.5">
          Pick 1 more to compare
        </div>
      )}
    </div>
  );
}
